module.exports = __webpack_public_path__ + "img/m_top_news.e103887d.jpg";